import { render, staticRenderFns } from "./Webinar-Tools.vue?vue&type=template&id=0cffd78d&scoped=true&"
import script from "./Webinar-Tools.vue?vue&type=script&lang=js&"
export * from "./Webinar-Tools.vue?vue&type=script&lang=js&"
import style0 from "./Webinar-Tools.vue?vue&type=style&index=0&id=0cffd78d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffd78d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
